import { render, staticRenderFns } from "./PeriodLevel2.vue?vue&type=template&id=fcf4ac50&scoped=true"
import script from "./PeriodLevel2.vue?vue&type=script&lang=js"
export * from "./PeriodLevel2.vue?vue&type=script&lang=js"
import style0 from "./PeriodLevel2.vue?vue&type=style&index=0&id=fcf4ac50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf4ac50",
  null
  
)

export default component.exports